interface IProps {
  src: string;
  altText: string;
}

export default function ImageViewer({ src, altText }: IProps) {
  return (
    <>
      <div className="h-full w-full flex justify-center items-center overflow-scroll">
        <div className="max-w-[75%]">
          <img src={src} alt={altText} className="w-full h-auto max-h-full" />
        </div>
      </div>
    </>
  );
}
